var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MapRoutesMultipleV2',{ref:"mapRoute",attrs:{"slot":"map","height":'540px',"width":'100%',"locations":_vm.routes,"lat":_vm.lat,"lng":_vm.lng},on:{"input":_vm.handleChange},slot:"map"})
}
var staticRenderFns = []

export { render, staticRenderFns }